declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', '26472237642370868')
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Camino a la Luz - Ebook',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}

export function trackInitiateCheckout(bonos: string, value: number) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: `Bonos: ${bonos}`,
      content_type: 'product',
      value,
      currency: 'USD',
    })
  }
}

export function trackAddBonus(bonusName: string) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'AddBonus', {
      bonus: bonusName,
      value: 9,
      currency: 'USD',
    })
  }
}

export function trackSkipBonus() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'SkipBonus')
  }
}
